export const toCents = (dollars: number): number => {
  return Math.round(Math.round(dollars * 100 * 100) / 100)
}

export const toDollars = (cents: number): number => {
  return cents / 100
}
